import React, { useState } from "react";
import {
    generateHiddenColumns
} from '../../Utils/Common';
import Table, { renderCellExpand } from '../../components/Table/Table';
import ActionDialog from "../../components/Dialogs/ActionDialog";
import { FormDialog } from "../../components/FormDialog/FormDialog";
//import HtmlTooltip from "../../components/HtmlToolTip/HtmlToolTip";
import Dialog from "@mui/material/Dialog";
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

const idpWorkflowDocumentStatusSchemaView = require("../../json/idpWorkflowDocumentStatusSchema.json").view;

const uiSchema = {
    "failedReferenceTaskNames": {
        "ui:options": {
            orderable: false,
            addable: false,
            removable: false
        }
    },
    "failedTaskNames": {
        "ui:options": {
            orderable: false,
            addable: false,
            removable: false
        }
    },
    "errorMessage": {
        "ui:options": {
            widget: "textarea",
            rows: 2
        }
    },
    "tasks": {
        "ui:options": {
            orderable: false,
            addable: false,
            removable: false
        },
        "items": {
            "outputData": {
                "ui:options": {
                    widget: "textarea",
                    rows: 7
                }
            },
            "errorMessage": {
                "ui:options": {
                    widget: "textarea",
                    rows: 2
                }
            },
            "ui:options": {
                orderable: false,
                addable: false,
                removable: false
            }
        }
    }
};

const DocumentIDPWorkflowStatusDialog = ({ open, onClose, data, viewTitle, jsonDataName }) => {

    const [rowJsonData, setRowJsonData] = useState({});
    const [openView, setOpenView] = useState(false);
    const [mode, setMode] = useState('view');  // default to view mode

    // need to add id for mui datagrid table
    let idpWorkflowStatusData = data.map((object, index) => {
        return { ...object, id: index + 1 };
    });

    const columns = [
        {
            field: 'id',
            type: 'number',
            headerName: 'ID',
            hide: true,
            minWidth: 50,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
        },
        {
            field: 'correlationId',
            headerName: 'Correlation ID',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand
        },
        {
            field: 'workflowId',
            headerName: 'Workflow ID',
            minWidth: 300,
            maxWidth: 300,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand
        },
        {
            field: 'status',
            headerName: 'Status',
            minWidth: 125,
            maxWidth: 125,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            field: 'workflowName',
            headerName: 'Workflow Name',
            minWidth: 200,
            maxWidth: 200,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },

        {
            field: 'startTime',
            headerName: 'Start Time',
            minWidth: 275,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            valueFormatter: (params) => {
                let formattedStartTime = "";
                if (params.value > 0) {
                    formattedStartTime = new Date(params.value).toISOString();
                }
                return formattedStartTime;
            },
            valueParser: (value) => {
                const date = new Date(value);
                return date.getTime();
            }
        },
        {
            field: 'finishTime',
            headerName: 'Finish Time',
            minWidth: 275,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            valueFormatter: (params) => {
                let formattedFinishTime = "";
                if (params.value > 0) {
                    formattedFinishTime = new Date(params.value).toISOString();
                }
                return formattedFinishTime;
            },
            valueParser: (value) => {
                const date = new Date(value);
                return date.getTime();
            }
        },

        {
            field: 'numberTotalTasks',
            headerName: 'Number Total Tasks',
            minWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            field: 'numberRunningTasks',
            headerName: 'Number Running Tasks',
            minWidth: 175,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },

        {
            field: 'numberSuccessTasks',
            headerName: 'Number Success Tasks',
            minWidth: 175,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            field: 'numberFailureTasks',
            headerName: 'Number Failure Tasks',
            minWidth: 175,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            field: 'reasonForIncompletion',
            headerName: 'Reason For Incompletion',
            minWidth: 250,
            maxWidth: 250,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {

                return (
                    <div style={{ flexDirection: 'column', display: 'inline-block', textAlign: 'left', wordBreak: 'break-word' }}>
                        {params.value}
                    </div>
                );
            }
        },
        {
            field: 'failedReferenceTaskNames',
            headerName: 'Failed Reference Task Names',
            minWidth: 250,
            maxWidth: 250,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {
                return (
                    <div style={{ flexDirection: 'column', display: 'inline-block', textAlign: 'left' }}>
                        {params.value && params.value.map((item) => <>{item}<br /></>)}
                    </div>
                );
            }
        },
        {
            field: 'failedTaskNames',
            headerName: 'Failed Task Names',
            minWidth: 250,
            maxWidth: 250,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {
                return (
                    <div style={{ flexDirection: 'column', display: 'inline-block', textAlign: 'left' }}>
                        {params.value && params.value.map((item) => <>{item}<br /></>)}
                    </div>
                );
            }
        },
        {
            field: 'errorMessage',
            headerName: 'Error Message',
            minWidth: 250,
            maxWidth: 250,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {

                return (
                    <div style={{ flexDirection: 'column', display: 'inline-block', textAlign: 'left', wordBreak: 'break-word' }}>
                        {params.value}
                    </div>
                );
            }
        }

    ];

    const handleIdpWorkflowStatusDialogClose = (event, reason) => {
        if (reason && reason === "backdropClick") {
            return;
        }
        onClose();
    };


    const formatData = (data) => {
        // check if object is not empty
        if (Object.keys(data).length !== 0) {
            data.startTime = data.startTime > 0 ? new Date(data.startTime).toISOString() : "";
            data.endTime = data.endTime > 0 ? new Date(data.endTime).toISOString() : "";

            data.tasks.forEach((obj) => {
                obj.startTime = obj.startTime > 0 ? new Date(obj.startTime).toISOString() : "";

                obj.endTime = obj.endTime > 0 ? new Date(obj.endTime).toISOString() : "";

                obj.scheduledTime = obj.scheduledTime > 0 ? new Date(obj.scheduledTime).toISOString() : "";

                // convert object to JSON string format
                obj.outputData = JSON.stringify(obj.outputData, null, 2);
            });
        }
    };


    const viewRowData = (param, event) => {

        // remove the id from table data as table data only not part of json stored
        const {
            id,
            ...JsonData
        } = param.row;

        let formattedData = JSON.parse(JSON.stringify(JsonData)); // make a deep copy to work on

        formatData(formattedData);

        setRowJsonData(formattedData);

        setMode('view');
        setOpenView(true);
    };

    const handleClose = () => {
        setOpenView(false);
    };

    const title = `Document IDP Workflow Status`;
    const buttonText = `Close`;

    return (

        <>
            <Dialog onClose={handleIdpWorkflowStatusDialogClose} open={open} maxWidth={'lg'} fullWidth={true}
                PaperProps={{
                    sx: {
                        maxWidth: '100%',
                        maxHeight: 545
                    }
                }}>
                <DialogTitle>
                    <div>{title}</div>
                    {onClose ? (
                        <IconButton
                            aria-label="close"
                            onClick={onClose}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    ) : null}
                </DialogTitle>
                <DialogContent dividers={true}>

                    <div id="ingestionJobStatusTableContainer" style={{ marginTop: '10px' }}>
                        <div >
                            <Table data={idpWorkflowStatusData} columns={columns} hiddenColumns={generateHiddenColumns(columns)} viewRowData={viewRowData} />
                        </div>
                    </div>
                </DialogContent>

                <DialogActions>
                    <Button variant="contained"
                        sx={{
                            color: '#333330',
                            backgroundColor: '#82C027',
                            boxShadow: '0px 1px 2px #6F7687',
                            borderRadius: '5px',
                            textTransform: 'none',
                            '&:hover': {
                                backgroundColor: '#82C027',
                                boxShadow: 'none'
                            }
                        }}
                        onClick={handleIdpWorkflowStatusDialogClose}>{buttonText}</Button>
                </DialogActions>

            </Dialog >

            {/* This dialog only support view. No need for form or save */}
            <ActionDialog
                open={openView}
                mode={mode}
                onClose={handleClose}
                title={viewTitle}
                defaultTab='JSON'
                propertiesTabContent={
                    <FormDialog
                        formId={'idpWorkflowStatusDialogId'}
                        readOnly={true}
                        schema={idpWorkflowDocumentStatusSchemaView}
                        uiSchema={uiSchema}
                        formData={rowJsonData}
                    />
                }
                jsonDataName={jsonDataName}
                JSONTabContent={rowJsonData}
            />



        </>
    );
}


export default DocumentIDPWorkflowStatusDialog;